/* global AuEmbed */

type GlobalWebsiteData = {
  sellerUrl: string
  source?: string
  departmentId?: string
  initialBrand?: string
  auCarId?: string
  scriptData: {
    device: string
    url: string
    ip: string
    depId?: string
  }
  customData: Record<string, string | number>
  stockId?: string
}
/**
 * Returns object with website data defined on the dealer's website
 * The data can be used to create a module url
 */
const getGlobalWebsiteData = (): GlobalWebsiteData => {
  return {
    // delayedCtaSellerUrl is used to explicitly set the sellerUrl
    // previewUrl is provided in case we want to "imitate" a website through website script examples
    // window.location.href is most commonly used to set the sellerUrl
    sellerUrl:
      window.AuEmbed.config.delayedCtaSellerUrl ||
      window.AuEmbed.config.previewUrl ||
      window.location.href,
    source: window.AuEmbed.config.delayedCtaSource,
    departmentId: window.AuEmbed.config.departmentId,
    initialBrand: window.AuEmbed.config.initialBrand,
    auCarId: window.AuEmbed.config.auCarId,
    scriptData: window.AuEmbed.config.scriptData,
    customData: window.AuEmbed.config.customData,
    stockId: window.AuEmbed.config.data && window.AuEmbed.config.data.stockId,
  }
}

export default getGlobalWebsiteData
